import { render, staticRenderFns } from "./ContactJoin.vue?vue&type=template&id=b3f105dc&"
import script from "./ContactJoin.vue?vue&type=script&lang=js&"
export * from "./ContactJoin.vue?vue&type=script&lang=js&"
import style0 from "./ContactJoin.vue?vue&type=style&index=0&id=b3f105dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports